import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ITeam, IEmployee } from '@signal/asp-data-commons';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ShopMaxPerDay, PerDaySlotsForCustomData, TechnicianSlotsPerTeam } from 'src/app/modules/shared/models/slot-management.model';
import { SlotState } from 'src/app/modules/store/slot/slot.reducer';
import { assetUrl } from 'src/single-spa/asset-url';
import * as fromActions from '../../../store/slot/slot.actions';
import * as fromSelector from '../../../store/slot/slot.selectors';
import * as fromSlotsSelector from '../../../store/slot/slot.selectors';
import { titleCase } from '../../../shared/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash'


@Component({
  selector: 'app-team-max',
  templateUrl: './team-max.component.html',
  styleUrls: ['./team-max.component.scss']
})
export class TeamMaxComponent implements OnInit, OnChanges, OnDestroy {
  @Input() viewMode: string;
  @Input() teams$: ITeam[];
  @Input() switchInput:boolean;
  @Input() totals$: PerDaySlotsForCustomData[];
  teamMaxForm: UntypedFormGroup;
  subscriptions: Subscription[] = [];
  subscriptionsnew: Subscription[] = [];
  shopMaxTotal$: Observable<ShopMaxPerDay[]>;
  slotTotals = {};
  slotTotalStatus = {};
  technicianSlotDetails$: Observable<{slots:TechnicianSlotsPerTeam, employees: IEmployee[]}>;
  technicianSlots: TechnicianSlotsPerTeam;
  technicians: IEmployee[];
  teamCapacity = []
  @Input() saveClicked:boolean
  @Input() cancleClicked:boolean
  @Input() allFormsEdited:boolean
  @Output() formEdited:EventEmitter<boolean> = new EventEmitter();
  @Output() cancleClick:EventEmitter<boolean> = new EventEmitter();
  @Output() saveClick:EventEmitter<boolean>=new EventEmitter();
  isFormEdited:boolean=false;
  lastValue:any
  //team slots save button
  isSaveClicked: boolean;

  constructor(
    private readonly slotState: Store<SlotState>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly translate: TranslateService
  ) {
    this.teamMaxForm = this.formBuilder.group({
      teamMaxDetails: this.formBuilder.array([])
    });
  }

  ngOnInit(): void {
    this.slotState.dispatch(new fromActions.LoadTeamMaxTotal());
    this.slotState.dispatch(new fromActions.LoadShopMaxTotal());
    this.shopMaxTotal$ = this.slotState.select(fromSelector.selectShopMaxTotal);
    this.subscriptions.push(
      this.shopMaxTotal$.subscribe(total => {
        this.calculateTotals(this.teamMaxForm.value.teamMaxDetails);
      })
    );
    this.subscriptions.push(this.teamMaxForm.valueChanges.subscribe(value => {
      this.calculateTotals(value.teamMaxDetails);
      this.formEdited.emit(this.teamMaxForm.dirty)

      if(this.viewMode==='Team' && this.teamMaxForm.dirty)
      {
        this.isSaveClicked=true
      }
    }));
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('totals$') && _.isEqual(this.teamMaxDetails.value,[])) {
      this.setTeamMaxDetails(this.teamMaxDetails, this.totals$);
    }
    if (changes.hasOwnProperty('teams$')) {
        if(this.teams$ && this.teams$.length>0){
          this.teamCapacity=[];
           for(var i=0;i<this.teams$.length;i++){
               this.technicianSlotDetails$ = this.slotState.select(fromSlotsSelector.selectTechnicianAndSlotsByTeamId, {teamId: this.teams$[i].id});

               this.subscriptionsnew.push(
                this.technicianSlotDetails$.subscribe(techAndslots => {
                  if(techAndslots.slots !== undefined){
                    this.technicianSlots = techAndslots.slots;
                    this.teamCapacity.push({'teamId':techAndslots.slots.teamId,'capacity':this.updateCapacity(techAndslots.slots.perDay)});
                    this.teamCapacity = this.getUniqueListBy(this.teamCapacity, 'teamId')
                    this.updateSlotTotals();
                  }
                })
              );
           }
        }
    }
   
    if(this.saveClicked && this.teamMaxForm.dirty )
    {
      this.onSave(); 
    }
    if(this.cancleClicked && this.teamMaxForm.dirty)
    {
      this.onCancel();
    }
  }

  updateSlotTotals(){
    var keys = Object.keys(this.slotTotals);
     for(var i=0;i<keys.length;i++){
       var totalCapacityOfTheDay = 0;
        for(var j=0;j<this.teamCapacity.length;j++){
           for(var k=0;k<this.teamCapacity[j].capacity.length;k++){
              var capacity = this.teamCapacity[j].capacity[k];
              if(this.teamCapacity[j].capacity[k].dayOfWeek == keys[i]){
                totalCapacityOfTheDay+=this.teamCapacity[j].capacity[k].capacity;
              }
           }
        }
        var slotArray = this.slotTotals[keys[i]].split('/');
        slotArray[0]=totalCapacityOfTheDay;
        this.slotTotalStatus[keys[i]] = assetUrl('icons/capacity-indicators/' + this.getCapacityIndicator(+slotArray[1] || 0, slotArray[0]) + '.svg');
        this.slotTotals[keys[i]] = slotArray.join('/');
     }
  }

  updateCapacity(data) {
    var perday = [];
    for(var i=0;i<data.length;i++) {
      var capacity = data[i].capacities;
      var total = 0;
      for(var j=0;j<capacity.length;j++) {
        if(capacity[j].capacity!=='' && capacity[j].capacity!==undefined && isNaN(capacity[j].capacity) == false &&
         capacity[j].capacity!==null){
          total+=parseInt(capacity[j].capacity)
        }

      };
      perday.push({dayOfWeek:data[i].dayOfWeek,hoursOfOperation:data[i].hoursOfOperation,capacity:total})
    };
    return perday;
  }

  getTableValue(capacity,day){
    let val=0;
     capacity.forEach(function(value){
       if(value['dayOfWeek']==day){
          val = value.capacity;
       }
     })
     return val;
  }

  getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  calculateTotals(slots: PerDaySlotsForCustomData[]) {
    this.subscriptions.push(this.shopMaxTotal$
      .pipe(take(1))
      .subscribe(shopMax => {
        if (slots && slots.length) {
          this.slotTotals = [];
          slots.forEach((data: PerDaySlotsForCustomData) => {
            let total = 0;
            const slotCapacity = this.viewMode === 'Team' ?
              shopMax.find(x => x.dayOfWeek === data.dayOfWeek)?.slotCapacity :
              shopMax.find(x => x.dayOfWeek === data.dayOfWeek)?.flatRateHours;
            this.teams$.forEach((team: ITeam) => {
              total += +data.capacities.find(x => x.id === team.id)?.capacity || 0;
            });
            const perDayTotal = total + '/' + (slotCapacity || 0);
            this.slotTotals[data.dayOfWeek] = perDayTotal;
            this.slotTotalStatus[data.dayOfWeek] = assetUrl('icons/capacity-indicators/' +
            this.getCapacityIndicator(slotCapacity || 0, total) + '.svg');
          })
          if(this.teamCapacity.length>0){
            this.updateSlotTotals();
          }
        }
      })
    );
  }

  getCapacityIndicator(slotCapacity, total) {
    return total === slotCapacity ? 'low-capacity' : (total === 0 || total > slotCapacity) ?
      'full-capacity' : 'half-capacity';
  }

  get teamMaxDetails() {
    return this.teamMaxForm.controls.teamMaxDetails as UntypedFormArray;
  }

  get capacities() {
    return this.teamMaxDetails.controls[0]?.get('capacities') as UntypedFormArray;
  }

  setTeamMaxDetails(formArray: UntypedFormArray, data: PerDaySlotsForCustomData[]) {
    if (data && data.length) {
      formArray.clear();
      data.forEach((total: PerDaySlotsForCustomData) => {
        if (total) {
          const arr = [];
          this.teams$.forEach(x => {
            const element = total.capacities?.find(y => y.id === x.id);
              arr.push(new UntypedFormGroup({
                id: new UntypedFormControl(x.id),
                capacity: new UntypedFormControl(element?.capacity)
              }));
          });
          formArray.push(new UntypedFormGroup({
            dayOfWeek: new UntypedFormControl(total.dayOfWeek),
            hoursOfOperation: new UntypedFormControl(total.hoursOfOperation),
            capacities: new UntypedFormArray(arr)
          }));
        }
      });
    }
  }
  getWeekDays(day)
  {
    return this.translate.instant(`common.${titleCase(day)}`);
  }


  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onSave() {
    if (this.viewMode === 'Team') {
      this.slotState.dispatch(new fromActions.UpdateTeamMaxTotal({ teamMaxTotal: this.teamMaxDetails.value ,allFormsEdited:false}))
      this.isSaveClicked=false
      this.teamMaxForm.markAsPristine()
      this.formEdited.emit(false);
    } else {
      this.slotState.dispatch(new fromActions.UpdateTechnicianMaxTotal({ technicianMaxTotal: this.teamMaxDetails.value }))
      this.saveClick.emit(false)
      this.formEdited.emit(false)
    }
  }

  onCancel() {
    this.setTeamMaxDetails(this.teamMaxDetails, this.totals$);
    if (this.viewMode === 'Team') {
      this.isSaveClicked=false
    }
    else
    {
      this.cancleClick.emit(false)
    }
  }
}
